import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";

import { CoreContext } from "context/CoreContext";
import { ReadLearningPaths } from "services/learning-paths";
import { exposeStrapiError } from "utils";
import { languages } from "utils/options";
import { getPortalConfig, normalizePortal } from "utils/portal";

export default function useController(portal) {
  const history = useHistory();
  const { language } = useContext(CoreContext);
  const resolvedPortal = normalizePortal(portal);
  const portalConfig = useMemo(() => getPortalConfig(resolvedPortal), [resolvedPortal]);
  const locale = useMemo(() => languages.find((item) => item.id === language)?.ref || "en", [language]);
  const [loading, setLoading] = useState(true);
  const [trails, setTrails] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    const result = await ReadLearningPaths({ portal: resolvedPortal, locale });
    if (!exposeStrapiError(result)) {
      setTrails(Array.isArray(result?.data) ? result.data : []);
    }
    setLoading(false);
  }, [locale, resolvedPortal]);

  useEffect(() => {
    load();
  }, [load]);

  const handleAction = useCallback((action, item) => {
    const id = item?.id || `${action?.value || ""}`.split("/").filter(Boolean).pop();
    if (!id) return;
    history.push(`${portalConfig.basePath}/trails/${id}`);
  }, [history, portalConfig.basePath]);

  return {
    loading,
    trails,
    handleAction,
  };
}
